import { actionTypes } from '../actions/reports.whatsapp.action';
const initialState = {
    campaigns: [],
    form: {

    },
    error: {},
    success: false
}

const ReportsWhatsappReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:

        return { ...state, ...payload }

    case actionTypes.CHANGE:
        return {
            ...state,
            form: (payload === 'clear') ? {} : {
                ...state.form,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default ReportsWhatsappReducer